<template>
  <v-menu content-class="mini-noti-parent" :close-on-content-click="false" :close-on-backdrop-click="false">
    <template v-slot:activator="{ props }">
      <v-btn class="noti-btn" v-bind="props" variant="text" :color="isHomePage ? 'white' : 'darkPrimary'">
        <v-badge color="error" :content="notiCount" :model-value="Boolean(notiCount && notiCount > 0)">
          <svg-icon type="mdi" :path="path"></svg-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card class="notification-card" min-width="350" max-width="500" elevation="0">
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <span class="text-h6">Bildirimler</span>
        <v-btn v-if="(miniNotificationList ?? []).length > 0" variant="text" density="comfortable" @click="setReadAll">
          <svg-icon type="mdi" :path="path"></svg-icon>
          Tümünü Okundu İşaretle
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-list class="notification-list" v-if="(miniNotificationList ?? []).length > 0">
        <v-list-item v-for="(item, index) in miniNotificationList" :key="index"
          :class="{ 'unread': !item.IsRead }" @click="setReadNotification(item)"
          class="notification-item">
          <template v-slot:prepend>
            <v-avatar :color="!item.IsRead ? 'primary' : 'grey-lighten-2'" size="40">
              <svg-icon :color="!item.IsRead ? 'white' : 'grey-darken-2'" type="mdi" :path="path"></svg-icon>
            </v-avatar>
          </template>
          <v-list-item-title class="font-weight-medium">{{ item.Title }}</v-list-item-title>
          <v-list-item-subtitle class="mt-1">{{ item.Body }}</v-list-item-subtitle>
          <div class="notification-meta">
            <span class="product-name">{{ item.ProductName }}</span>
          </div>
        </v-list-item>
      </v-list>

      <v-sheet v-else class="pa-4 text-center">
        <svg-icon type="mdi" :path="path"></svg-icon>
        <div class="text-body-1 mt-2 text-grey">Bildirim bulunamadı.</div>
      </v-sheet>

      <v-divider></v-divider>

      <v-card-actions class="pa-2">
        <v-btn block color="primary" variant="tonal" to="/profil/bildirimler">
          Tümünü Gör
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "pinia";
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiBell, mdiCheckAll } from '@mdi/js';
export default defineComponent({
  name: "bildirimler-mini",
  components: {
    SvgIcon
  },
  data() {
    return {
      menuVisible: false,
      path: mdiBell,
      pathCheckAll: mdiCheckAll,
      route:useRoute(),
    };
  },
  computed: {
    isThereAnyNotification() {
      if (typeof window !== 'undefined') {
        if (this.getUnreadCount > 0) {
          return true;
        }
        return false;
      }
    },
    isHomePage() {
      return this.route.path === '/';
    },
    ...mapState(useMyNotificationsStore, ["getNotificationMini", "getUnreadCount"]),
    miniNotificationList() {
      if (typeof window !== 'undefined') {
        return this.getNotificationMini;
      }
    },

    notiCount() {
      if (typeof window !== 'undefined') {
        return this.getUnreadCount;
      }
    },


  },
  mounted() {
  },
  beforeUnmount() {
  },
  methods: {
    setReadAll() {
      const useStore = useMyNotificationsStore();
      useStore.setReadAllNotifications();
    },
    async setReadNotification(item: any) {
      const router = useRouter();
      if (item.IsRead) {
        router.push("/profil/bildirimler");
        return;
      }
      else {
        const useStore = useMyNotificationsStore();
        await useStore.setReadNotification(item.Id);
        router.push("/profil/bildirimler");
      }

    },
  },
  watch: {

  },

});
</script>

<style lang="less">
.mini-noti-parent {
  .notification-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--color-grey-border);
    .v-card-title {
      background-color: var(--color-grey-white-background);
      border-bottom: 1px solid var(--color-grey-border);
    }
  }

  .notification-list {
    max-height: 400px;
    overflow-y: auto;
    background-color: var(--color-grey-white-background);

    .notification-item {
      padding: 16px;
      transition: background-color 0.2s ease;
      border-bottom: 1px solid var(--color-grey-border);
      cursor: pointer;

      &:hover {
        background-color: var(--color-grey-hover);
      }

      &.unread {
        background-color: var(--color-grey-white-background);
      }

      .v-list-item-title {
        font-size: 14px;
        line-height: 1.4;
        color: var(--color-text);
      }

      .v-list-item-subtitle {
        font-size: 13px;
        color: var(--color-text-secondary);
        margin-top: 4px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .notification-meta {
        margin-top: 8px;
        display: flex;
        align-items: center;
        gap: 8px;

        .product-name {
          font-size: 12px;
          color: var(--color-primary);
          font-weight: 500;
        }
      }
    }
  }
}

.noti-btn {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 20px;

  &:hover {
    background-color: var(--color-grey-hover);
  }

  .v-badge__badge {
    font-size: 12px;
    min-width: 20px;
    height: 20px;
    border-radius: 10px;
  }
}
</style>
